/* global FB */
let done = false

export default function init() {
	if (done) {
		return Promise.resolve()
	}

	return new Promise((resolve) => {
		window.fbAsyncInit = () => {
			FB.init({
				appId: process.config.facebook,
				xfbml: true,
				version: 'v2.8',
			})
			FB.AppEvents.logPageView()

			done = true
			resolve(FB)
		};

		/* eslint-disable */
		(function (d, s, id) {
			var js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) { return; }
			js = d.createElement(s); js.id = id;
			js.src = "//connect.facebook.net/en_US/sdk.js";
			fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));
		/* eslint-enable */
	})
}



// WEBPACK FOOTER //
// ./src/services/FacebookService.js